import { EBrandName, TInfoBox } from "@/types/TInfoBox"
import ExternalLink from "./external-link";
import DomcuraLogo from "@/assets/domcura-logo.png";
import NordiasLogo from "@/assets/nordias-logo.png";
import InnoasLogo from "@/assets/innoas-logo.png";
import NordversLogo from "@/assets/nordvers-logo.png";

type TBrandGroup = {
  group: TInfoBox;
}

export default function BrandGroup({ group: { brand, items } }: TBrandGroup) {
  if (items.length === 0) {
    return null;
  }

  const getSrc = (): string | undefined => {
    switch (brand) {
      case EBrandName.domcura:
        return DomcuraLogo;
      case EBrandName.nordias:
        return NordiasLogo;
      case EBrandName.innoas:
        return InnoasLogo;
      case EBrandName.nordvers:
        return NordversLogo;
      default:
        return undefined;
    }
  }

  const logoSrc = getSrc();

  return (
    <div>
      {brand !== EBrandName.default && logoSrc && (
        <img
          src={logoSrc}
          alt={`${brand} logo`}
          className="m-auto max-w-[80%] p-2 max-h-[50px]"
        />
      )}
      <div className="gap-2 flex flex-col px-6 pb-2 text-md items-end overflow-y-auto max-h-full max-w-full">
        {items.map((item, index) => (
          <ExternalLink
            key={index}
            item={item}
          />
        ))}
      </div>
    </div>
  )
}